module.exports = __webpack_public_path__ + "static/falafelIcon-afbfb311213b171a3075307eaf798529.png";